export default {
  register_time: 'Fecha y hora de registro',
  authorization_status: 'Estado de autorización',
}
